import * as types from '../actions/actionTypes'
import initialState from './initialState'
import intialState from './initialState'

export default function topBanner(state = intialState.top_banner, action) {
    switch (action.type) {
        case types.CHANGE_TOPBANNER:
            return {
                ...state,
                page: action.topBanner.page,
                showSearch: action.topBanner.showSearch,
                isHome: action.topBanner.isHome,
                globalSearch: action.topBanner.globalSearch,
                arrCategory: action.topBanner.arrCategory,
                onSearch: action.topBanner.onSearch,
            }
        case types.SET_BUSINESS:
            return {
                ...state,
                business: action.business,
            }
        case types.INITIALIZE_SEARCH_KEY:
            return {
                ...state,
                searchKey: initialState.global.searchKey
            };
        case types.SET_SEARCH_KEY:
            return {
                ...state,
                searchKey: action.search
            }
        default:
            return state
    }
}
